const functions = { sqrt: Math.sqrt, abs: Math.abs, sin: Math.sin, cos: Math.cos, tan: Math.tan, ln: Math.log, log: Math.log10, exp: Math.exp };
// A deliberately small grammar. Never evaluates JavaScript or accesses objects.
export function parseMathExpression(input, { symbolic = false } = {}) {
  if (typeof input !== 'string' || !input.trim() || input.length > 128) throw new Error('Expression invalide (128 caractères maximum).');
  const text = input.replace(/,/g, '.').replace(/×/g, '*').replace(/÷/g, '/').replace(/−/g, '-').replace(/π/g, 'pi');
  const tokens = text.match(/(?:\d+(?:\.\d*)?|\.\d+)(?:[eE][+-]?\d+)?|[a-z]+|[()+*/^-]|\S/g) || [];
  let index = 0, depth = 0;
  const take = token => tokens[index] === token && (++index, true);
  const node = (value, tex) => ({ value, tex });
  const group = a => `\\left(${a.tex}\\right)`;
  function primary() {
    if (++depth > 24) throw new Error('Expression trop imbriquée.');
    let result;
    const token = tokens[index++];
    if (/^(?:\d+(?:\.\d*)?|\.\d+)(?:[eE][+-]?\d+)?$/.test(token || '')) result = node(Number(token), token.replace(/[eE]([+-]?\d+)/, '\\times 10^{$1}'));
    else if (token === '(') { result = sum(); if (!take(')')) throw new Error('Ferme la parenthèse.'); result = node(result.value, group(result)); }
    else if (token === 'pi' || token === 'e') result = node(token === 'pi' ? Math.PI : Math.E, token === 'pi' ? '\\pi' : 'e');
    else if (Object.hasOwn(functions, token)) {
      if (!take('(')) throw new Error('La fonction attend une parenthèse.');
      const arg = sum(); if (!take(')')) throw new Error('Ferme la parenthèse.');
      const tex = token === 'sqrt' ? `\\sqrt{${arg.tex}}` : token === 'abs' ? `\\left|${arg.tex}\\right|` : `\\operatorname{${token}}${group(arg)}`;
      result = node(functions[token](arg.value), tex);
    } else if (symbolic && ['x', 'y'].includes(token)) result = node(NaN, token);
    else throw new Error('Utilise un nombre, une fraction ou une fonction proposée dans l’aide.');
    depth--; return result;
  }
  function power() { const a = primary(); if (!take('^')) return a; const b = unary(); return node(a.value ** b.value, `{${a.tex}}^{${b.tex}}`); }
  function unary() { if (take('+')) return unary(); if (take('-')) { const a = unary(); return node(-a.value, `-${a.tex}`); } return power(); }
  function product() {
    let a = unary();
    while (tokens[index] === '*' || tokens[index] === '/') { const op = tokens[index++], b = unary(); a = op === '*' ? node(a.value * b.value, `${a.tex}\\cdot ${b.tex}`) : node(a.value / b.value, `\\frac{${a.tex}}{${b.tex}}`); }
    return a;
  }
  function sum() { let a = product(); while (tokens[index] === '+' || tokens[index] === '-') { const op = tokens[index++], b = product(); a = node(op === '+' ? a.value + b.value : a.value - b.value, `${a.tex}${op}${b.tex}`); } return a; }
  const result = sum();
  if (index !== tokens.length) throw new Error('Vérifie les opérateurs et les parenthèses.');
  if (!symbolic && !Number.isFinite(result.value)) throw new Error('Cette expression ne donne pas un nombre réel fini.');
  return result;
}
export function numericAnswer(input) { return parseMathExpression(input).value; }
